import { useContext } from 'react'
import { SessionDataContext } from '../context/SessionDataContext'

export default function TaskDescription() {
  const { sessionData } = useContext(SessionDataContext)

  return (
    <div className="task-description">
      <h2>Task Description</h2>
      <div className="task-content" style={{
        whiteSpace: 'pre-line',
        backgroundColor: '#f5f5f5',
        padding: '12px',
        borderRadius: '6px',
      }}>
        {sessionData?.taskDescription || 'No task description available'}
      </div>
    </div>
  )
}